import { render } from "./PCP_RETAILERS.vue?vue&type=template&id=32a01da2"
import script from "./PCP_RETAILERS.vue?vue&type=script&lang=ts"
export * from "./PCP_RETAILERS.vue?vue&type=script&lang=ts"
script.render = render

export default script